import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';


function dhtmlXCombo(l, r, e, n, h) {
    var m = this;
    var g = null;
    var s = null;
    if (typeof (l) == "object" && !l.tagName) {
        g = l;
        l = g.parent;
        e = g.width;
        r = g.name;
        n = g.mode;
        s = g.skin;
    }
    this.cont = (typeof (l) == "string" ? document.getElementById(l) : l);
    this.conf = {
        skin: null,
        form_name: r || "dhxcombo",
        combo_width: (parseInt(e) || this.cont.offsetWidth || 120) - (dhx4.isFF || dhx4.isIE || dhx4.isChrome || dhx4.isOpera ? 2 : 0),
        combo_image: false,
        combo_focus: false,
        opts_type: (typeof (n) == "string" && typeof (this.modes[n]) != "undefined" ? n : "option"),
        opts_count: 8,
        opts_count_min: 3,
        opts_width: null,
        item_h: null,
        list_zi_id: dhx4.newId(),
        allow_free_text: true,
        allow_empty_value: true,
        free_text_empty: false,
        enabled: true,
        btn_left: ((dhx4.isIE6 || dhx4.isIE7 || dhx4.isIE8) && typeof (window.addEventListener) == "undefined" ? 1 : 0),
        ro_mode: false,
        ro_text: "",
        ro_tm: null,
        ro_tm_time: 750,
        img_path: "",
        img_def: "",
        img_def_dis: true,
        template: {header: true, input: "#text#", option: "#text#"},
        f_func: null,
        f_mode: false,
        f_url: false,
        f_cache: false,
        f_cache_data: {},
        f_dyn: false,
        f_dyn_end: false,
        f_mask: "",
        f_ac: true,
        f_ac_text: "",
        f_server_tm: null,
        f_server_last: "",
        f_loading: false,
        s_tm: null,
        s_time: 200,
        s_mode: "select",
        last_hover: null,
        last_selected: null,
        last_match: null,
        last_text: "",
        last_value: "",
        tm_hover: null,
        tm_confirm_blur: null,
        clear_click: false,
        clear_blur: false,
        clear_bsp: false,
        clear_key: false,
        i_ofs: 23,
        sp: {
            dhx_skyblue: {list_ofs: 1, hdr_ofs: 1, scr_ofs: 1},
            dhx_web: {list_ofs: 0, hdr_ofs: 1, scr_ofs: 0},
            dhx_terrace: {list_ofs: 1, hdr_ofs: 1, scr_ofs: 1},
            material: {list_ofs: 0, hdr_ofs: 1, scr_ofs: 1}
        },
        col_w: null
    };
    this.conf.combo_image = (this.modes[this.conf.opts_type].image == true);
    this.t = {};
    this.base = document.createElement("DIV");
    this.base.style.width = this.conf.combo_width + "px";
    this.base.innerHTML = "<input type='text' class='dhxcombo_input' style='width:" + (this.conf.combo_width - (this.conf.i_ofs + 1) - (this.conf.combo_image ? this.conf.i_ofs : 0)) + "px;" + (this.conf.combo_image ? "margin-left:" + this.conf.i_ofs + "px;" : "") + "' autocomplete='off'><input type='hidden' value=''><input type='hidden' value='false'><div class='dhxcombo_select_button'><div class='dhxcombo_select_img'></div></div>" + (this.conf.combo_image ? "<div class='dhxcombo_top_image'>" + this.modes[this.conf.opts_type].getTopImage(null, this.conf.enabled) + "</div>" : "");
    this.cont.appendChild(this.base);
    this.list = document.createElement("DIV");
    this.list._listId = dhx4.newId();
    this.list.style.display = "none";
    document.body.insertBefore(this.list, document.body.firstChild);
    this._doOnListScroll = function () {
        if (m.conf.s_tm != null) {
            window.clearTimeout(m.conf.s_tm);
        }
        m.conf.s_tm = window.setTimeout(m._doOnListScrollAction, m.conf.s_time);
    };
    this._doOnListScrollAction = function () {
        m.conf.s_tm = null;
        if (m.conf.s_mode == "scroll" && m.list.scrollHeight - m.list.scrollTop - 10 < m.list.clientHeight) {
            m._subloadRequest();
        }
    };
    if (typeof (window.addEventListener) == "function") {
        this.list.addEventListener("scroll", this._doOnListScroll, false);
    } else {
        this.list.attachEvent("onscroll", this._doOnListScroll);
    }
    this.setSkin(s || dhx4.skin || (typeof (dhtmlx) != "undefined" ? dhtmlx.skin : null) || dhx4.skinDetect("dhxcombo") || "material");
    this._updateTopImage = function (a) {
        if (!this.conf.combo_image) {
            return;
        }
        if (a != null) {
            this.base.lastChild.innerHTML = this.t[a].obj.getTopImage(this.t[a].item, this.conf.enabled);
        } else {
            this.base.lastChild.innerHTML = this.modes[this.conf.opts_type].getTopImage(null, this.conf.enabled);
        }
    };
    this._filterOpts = function (A) {
        if (this.conf.f_server_tm) {
            window.clearTimeout(this.conf.f_server_tm);
        }
        var w = String(this.base.firstChild.value).replace(new RegExp(this._fixRE(this.conf.f_ac_text) + "$", "i"), "");
        if (this.conf.f_server_last == w.toLowerCase()) {
            this._checkForMatch();
            return;
        }
        if (this.conf.f_url != null && this.checkEvent("onDynXLS")) {
            this.conf.f_server_last = w.toLowerCase();
            this.callEvent("onDynXLS", [w]);
            return;
        }
        if (this.conf.f_url != null) {
            if (w.length == 0) {
                this.conf.f_server_last = w.toLowerCase();
                this.clearAll();
                return;
            }
            if (this.conf.f_cache == true && this.conf.f_cache_data[w] != null) {
                this.clearAll();
                this.conf.f_server_last = w.toLowerCase();
                for (var v = 0; v < this.conf.f_cache_data[w].data.length; v++) {
                    this.load(this.conf.f_cache_data[w].data[v]);
                }
                if (this.conf.f_dyn) {
                    this.conf.f_dyn_end = this.conf.f_cache_data[w].dyn_end;
                    this.conf.f_mask = this.conf.f_cache_data[w].mask;
                }
                if (A !== true) {
                    this._showList(true);
                    this._checkForMatch();
                }
            } else {
                this.conf.f_server_tm = window.setTimeout(function () {
                    m.conf.f_server_last = w.toLowerCase();
                    m.conf.f_mask = w;
                    var F = "mask=" + encodeURIComponent(w);
                    if (m.conf.f_dyn) {
                        F += "&pos=0";
                        m.conf.f_dyn_end = false;
                    }
                    var a = function (J) {
                        if (m.conf.f_cache) {
                            if (!m.conf.f_cache_data[w]) {
                                m.conf.f_cache_data[w] = {data: [], dyn_end: false, mask: w};
                            }
                            m.conf.f_cache_data[w].data.push(J.xmlDoc.responseXML);
                        }
                        m.clearAll();
                        m.load(J.xmlDoc.responseXML);
                        var I = (m.base.offsetWidth > 0 && m.base.offsetHeight > 0);
                        if (I == true && m.conf.enabled == true && m.conf.combo_focus == true && A !== true) {
                            if (m.conf.f_ac && m.conf.f_mode == "start" && m.conf.clear_bsp == false && m.list.firstChild != null) {
                                var H = m.list.firstChild._optId;
                                var K = String(m.t[H].obj.getText(m.list.firstChild, true));
                                if (w == m.base.firstChild.value && String(K).toLowerCase().indexOf(String(w).toLowerCase()) === 0) {
                                    m.base.firstChild.value = K;
                                    m.conf.f_ac_text = K.substr(w.length);
                                    m._selectRange(w.length, K.length)
                                }
                            }
                            m._showList(true);
                            m._checkForMatch();
                        }
                        a = null;
                    };
                    if (dhx4.ajax.method == "post") {
                        dhx4.ajax.post(m.conf.f_url, F, a);
                    } else {
                        if (dhx4.ajax.method == "get") {
                            dhx4.ajax.get(m.conf.f_url + (String(m.conf.f_url).indexOf("?") >= 0 ? "&" : "?") + F, a);
                        }
                    }
                }, 200);
            }
        } else {
            this.conf.f_server_last = w.toLowerCase();
            var u = (w.length == 0 ? true : new RegExp((this.conf.f_mode == "start" ? "^" : "") + this._fixRE(w), "i"));
            var x = null;
            for (var C in this.t) {
                var E = false;
                if (u !== true) {
                    if (this.conf.f_func != null) {
                        var y = this._getOption(this.t[C].item._optId, v);
                        E = (this.conf.f_func.apply(window, [w, y]) == true);
                    } else {
                        var D = this.t[C].obj.getText(this.t[C].item, true);
                        E = (u.test(D) == true);
                    }
                }
                if (u === true || E == true) {
                    this.t[C].item.style.display = "";
                    if (x == null && w.length > 0) {
                        x = String(this.t[C].obj.getText(this.t[C].item, true));
                    }
                } else {
                    this.t[C].item.style.display = "none";
                }
            }
            if (this.conf.f_ac && this.conf.f_mode == "start" && this.conf.clear_bsp == false && x != null) {
                this.conf.f_ac_text = x.replace(new RegExp("^" + w, "i"), "");
                this.base.firstChild.value = x;
                this._selectRange(this.conf.f_server_last.length, this.base.firstChild.value.length);
            }
            if (this.conf.f_mode == "between" && this.conf.clear_bsp == true) {
                this._checkForMatch(true);
            }
            if (A !== true) {
                this._showList(true);
                this._checkForMatch();
            }
        }
    };
    this._searchRO = function (u) {
        if (this.conf.ro_tm) {
            window.clearTimeout(this.conf.ro_tm);
        }
        this.conf.ro_text += u;
        this._showList();
        for (var v = 0; v < this.list.childNodes.length; v++) {
            var a = this.list.childNodes[v]._optId;
            var w = String(this.t[a].obj.getText(this.list.childNodes[v], true)).toLowerCase();
            if (w.indexOf(this.conf.ro_text) === 0) {
                this._setSelected(a, true, true);
                this._confirmSelect("script", false);
                break;
            }
        }
        this.conf.ro_tm = window.setTimeout(function () {
            m.conf.ro_text = "";
        }, this.conf.ro_tm_time);
    };
    this._fixRE = function (a) {
        return String(a).replace(/[\\\^\$\*\+\?\.\(\)\|\{\}\[\]]/gi, "\\$&");
    };
    this._initObj = function (a) {
        if (typeof (a.template) != "undefined") {
            this.setTemplate(a.template);
        }
        if (a.add != true && this.conf.f_loading != true) {
            this.clearAll(false);
        }
        this.addOption(a.options);
    };
    this._xmlToObj = function (P, x, v) {
        var C = {add: false, options: []};
        var J = (x == true ? P : P.getElementsByTagName("complete"));
        if (J.length > 0) {
            if (dhx4.s2b(J[0].getAttribute("add")) == true) {
                C.add = true;
            }
            var I = J[0].childNodes;
            for (var F = 0; F < I.length; F++) {
                if (typeof (I[F].tagName) != "undefined") {
                    if (String(I[F].tagName).toLowerCase() == "template") {
                        var O = {};
                        for (var A = 0; A < I[F].childNodes.length; A++) {
                            var H = I[F].childNodes[A];
                            if (H.tagName != null) {
                                var K = H.tagName;
                                if (typeof (this.conf.template[K]) != "undefined") {
                                    O[K] = dhx4._xmlNodeValue(H);
                                }
                                if (K == "columns") {
                                    for (var M = 0; M < H.childNodes.length; M++) {
                                        var y = H.childNodes[M];
                                        if (y.tagName != null && y.tagName == "column") {
                                            var E = {};
                                            for (var N in {width: 1, css: 1, header: 1, option: 1}) {
                                                if (y.getAttribute(N) != null) {
                                                    E[N] = y.getAttribute(N);
                                                }
                                            }
                                            for (var N in {header: 1, option: 1}) {
                                                var L = y.getElementsByTagName(N);
                                                if (L[0] != null && L[0].firstChild != null) {
                                                    E[N] = dhx4._xmlNodeValue(L[0]);
                                                }
                                            }
                                            if (O.columns == null) {
                                                O.columns = [];
                                            }
                                            O.columns.push(E);
                                        }
                                        y = null;
                                    }
                                }
                            }
                            H = null;
                        }
                        this.setTemplate(O);
                    }
                    if (String(I[F].tagName).toLowerCase() == "option") {
                        var D = false;
                        if (x == true) {
                            D = (C.options.length == v);
                        } else {
                            D = dhx4.s2b(I[F].getAttribute("selected"));
                        }
                        var u = {
                            value: I[F].getAttribute("value"),
                            text: dhx4._xmlNodeValue(I[F]),
                            selected: D,
                            checked: dhx4.s2b(I[F].getAttribute("checked"))
                        };
                        for (var N in {img: 1, img_dis: 1, img_src: 1, img_src_dis: 1, css: 1}) {
                            if (I[F].getAttribute(N) != null) {
                                u[N] = I[F].getAttribute(N)
                            }
                        }
                        for (var A = 0; A < I[F].childNodes.length; A++) {
                            if (I[F].childNodes[A].tagName != null && String(I[F].childNodes[A].tagName).toLowerCase() == "text") {
                                u.text = {};
                                var H = I[F].childNodes[A];
                                for (var M = 0; M < H.childNodes.length; M++) {
                                    if (H.childNodes[M].tagName != null) {
                                        u.text[H.childNodes[M].tagName] = dhx4._xmlNodeValue(H.childNodes[M]);
                                    }
                                }
                            }
                        }
                        C.options.push(u);
                    }
                }
            }
            J = I = null;
        }
        return C;
    };
    dhx4._enableDataLoading(this, "_initObj", "_xmlToObj", "complete", {data: true});
    dhx4._eventable(this);
    this._getNearItem = function (v, u) {
        var a = null;
        while (v != null) {
            v = v[u < 0 ? "previousSibling" : "nextSibling"];
            if (a == null && v != null && v.style.display == "" && v._optId != null) {
                a = v;
                v = null;
            }
        }
        return a;
    };
    this.setName(this.conf.form_name);
    this._doOnListMouseMove = function (u) {
        u = u || event;
        var a = u.target || u.srcElement;
        while (a != null && a != this) {
            if (typeof (a._optId) != "undefined") {
                if (m.conf.tm_hover) {
                    window.clearTimeout(m.conf.tm_hover);
                }
                m._setSelected(a._optId, false, false, true);
            }
            a = a.parentNode;
        }
        a = null;
    };
    this._doOnListMouseDown = function (a) {
        a = a || event;
        a.cancelBubble = true;
        m.conf.clear_click = true;
        window.setTimeout(function () {
            m.base.firstChild.focus();
        }, 1);
    };
    this._doOnListMouseUp = function (v) {
        v = v || event;
        if (v.button != m.conf.btn_left) {
            return
        }
        var a = v.target || v.srcElement;
        while (a != null && a != this) {
            if (typeof (a._optId) != "undefined") {
                var u = true;
                if (typeof (m.t[a._optId].obj.optionClick) == "function" && m.t[a._optId].obj.optionClick(a, v, m) !== true) {
                    u = false
                }
                if (u) {
                    m._setSelected(a._optId, null, true);
                    m._confirmSelect("click");
                }
            }
            a = a.parentNode;
        }
        a = null;
    };
    this._doOnListMouseOut = function (a) {
        if (m.conf.tm_hover) {
            window.clearTimeout(m.conf.tm_hover);
        }
        m.conf.tm_hover = window.setTimeout(function () {
            var u = m.conf.last_match || m.conf.last_selected;
            if (m.conf.last_match == null && m.t[u] != null) {
                if (m.base.firstChild.value != m.t[u].obj.getText(m.t[u].item, true)) {
                    u = null;
                }
            }
            m._setSelected(u, null, true, true);
        }, 1);
    };
    this._doOnBaseMouseDown = function (x) {
        if (!m.conf.enabled) {
            return
        }
        m.conf.clear_click = true;
        x = x || event;
        if (x.button != m.conf.btn_left) {
            return;
        }
        var u = x.target || x.srcElement;
        if (u != this.firstChild) {
            window.setTimeout(function () {
                m.base.firstChild.focus();
            }, 1);
            var w = u;
            while (w != this && w != null) {
                if (w == this.lastChild) {
                    if (typeof (m.modes[m.conf.opts_type].topImageClick) == "function") {
                        var v = (m.conf.last_hover || m.conf.last_selected);
                        var a = (v != null ? m.t[v].item : null);
                        if (m.modes[m.conf.opts_type].topImageClick(a, m) !== true) {
                            v = a = null;
                            return;
                        }
                    }
                    w = null;
                } else {
                    w = w.parentNode;
                }
            }
        }
        if (m._isListVisible()) {
            m._hideList();
        } else {
            if (u != this.firstChild) {
                m.conf.clear_blur = true;
            }
            m._showList();
            m._setSelected(m.conf.last_selected, true, true);
        }
        u = null;
    };
    this._doOnBodyMouseDown = function () {
        if (m.conf.clear_click) {
            m.conf.clear_click = false;
            return;
        }
        m._confirmSelect("blur");
    };
    this._doOnInputFocus = function () {
        m.conf.clear_blur = false;
        if (m.conf.tm_confirm_blur) {
            window.clearTimeout(m.conf.tm_confirm_blur);
        }
        if (m.conf.combo_focus == false) {
            m.conf.combo_focus = true;
            if (m.conf.skin == "material" && m.base.className.match(/dhxcombo_actv/) == null) {
                m.base.className += " dhxcombo_actv";
            }
            m.callEvent("onFocus", []);
        }
    };
    this._doOnInputBlur = function () {
        if (m.conf.clear_blur == true) {
            m.conf.clear_blur = false;
            return;
        }
        if (m.conf.tm_confirm_blur) {
            window.clearTimeout(m.conf.tm_confirm_blur);
        }
        m.conf.tm_confirm_blur = window.setTimeout(function () {
            if (m.conf.clear_click == false) {
                m._confirmSelect("blur");
                m.conf.combo_focus = false;
                if (m.conf.skin == "material" && m.base.className.match(/dhxcombo_actv/) != null) {
                    m.base.className = m.base.className.replace(/\s*dhxcombo_actv/gi, "")
                }
                m.callEvent("onBlur", []);
            }
        }, 20);
    };
    this._doOnInputKeyUp = function (a) {
        a = a || event;
        if (m.conf.f_mode != false) {
            m.conf.clear_bsp = (a.keyCode == 8 || a.keyCode == 46);
            m._filterOpts();
            return;
        } else {
            m._checkForMatch();
        }
    };
    this._doOnInputKeyDown = function (a) {
        a = a || event;
        if ((a.keyCode == 38 || a.keyCode == 40) && !a.ctrlKey && !a.shiftKey && !a.altKey) {
            if (a.preventDefault) {
                a.preventDefault();
            } else {
                a.returnValue = false;
            }
            a.cancelBubble = true;
            m._keyOnUpDown(a.keyCode == 38 ? -1 : 1);
        }
        if (a.keyCode == 113) {
            if (!m._isListVisible()) {
                m._showList();
                if (m.base.firstChild.value == m.conf.last_text) {
                    m._setSelected(m.conf.last_selected, true, true);
                    m.base.firstChild.value = m.conf.last_text;
                    m.conf.f_server_last = m.base.firstChild.value.toLowerCase();
                } else {
                    m.conf.f_server_last = m.base.firstChild.value.toLowerCase();
                    if (m.conf.f_mode == false) {
                        m._checkForMatch();
                    }
                }
            }
        }
        if (a.keyCode == 27) {
            if (a.preventDefault) {
                a.preventDefault();
            } else {
                a.returnValue = false;
            }
            a.cancelBubble = true;
            m._cancelSelect();
        }
        if (a.keyCode == 13) {
            if (a.preventDefault) {
                a.preventDefault();
            }
            m._confirmSelect("kbd");
        }
        if (m.conf.ro_mode == true && ((a.keyCode >= 48 && a.keyCode <= 57) || (a.keyCode >= 65 && a.keyCode <= 90))) {
            m._searchRO(String.fromCharCode(a.keyCode).toLowerCase());
            a.cancelBubble = true;
        }
        m.conf.clear_key = true;
        m.callEvent("onKeyPressed", [a.keyCode || a.charCode]);
    };
    this._doOnInputKeyPress = function (a) {
        if (m.conf.clear_key) {
            m.conf.clear_key = false;
            return;
        }
        a = a || event;
        m.callEvent("onKeyPressed", [a.keyCode || a.charCode]);
    };
    this._keyOnUpDown = function (a) {
        var u = null;
        if (this.conf.last_hover) {
            u = this.t[this.conf.last_hover].item;
        } else {
            if (this.conf.last_selected) {
                u = this.t[this.conf.last_selected].item;
            }
        }
        if (!u && this._getListVisibleCount() == 0) {
            return;
        }
        if (u != null && u.style.display != "") {
            u = null;
        }
        this._showList();
        if (u != null) {
            if (this.t[u._optId].obj.isSelected(u)) {
                u = this._getNearItem(u, a);
            }
        } else {
            u = this.list.firstChild;
            if (u.style.display != "") {
                u = this._getNearItem(u, 1);
            }
        }
        if (u == null) {
            return;
        }
        this._setSelected(u._optId, true, true);
        if (this.conf.f_mode == false) {
            this.base.firstChild.value = this.t[u._optId].obj.getText(u, true);
        } else {
            var v = String(this.t[u._optId].obj.getText(u, true));
            if (this.conf.f_mode == "start" && this.conf.f_ac == true) {
                if (v.toLowerCase().indexOf(this.conf.f_server_last) === 0) {
                    this.conf.f_ac_text = v.substring(this.conf.f_server_last.length, v.length);
                    this.base.firstChild.value = v;
                    this._selectRange(this.conf.f_server_last.length, this.base.firstChild.value.length);
                } else {
                    this.base.firstChild.value = v;
                    this.conf.f_server_last = this.base.firstChild.value.toLowerCase();
                    this._selectRange(0, this.base.firstChild.value.length);
                }
            } else {
                this.base.firstChild.value = v;
                this.conf.f_server_last = this.base.firstChild.value.toLowerCase();
            }
        }
        u = null;
    };
    this.conf.evs_nodes = [{node: document.body, evs: {mousedown: "_doOnBodyMouseDown"}}, {
        node: this.base,
        evs: {mousedown: "_doOnBaseMouseDown"}
    }, {
        node: this.base.firstChild,
        evs: {
            keyup: "_doOnInputKeyUp",
            keydown: "_doOnInputKeyDown",
            keypress: "_doOnInputKeyPress",
            focus: "_doOnInputFocus",
            blur: "_doOnInputBlur"
        }
    }, {
        node: this.list,
        evs: {
            mousemove: "_doOnListMouseMove",
            mousedown: "_doOnListMouseDown",
            mouseup: "_doOnListMouseUp",
            mouseout: "_doOnListMouseOut"
        }
    }];
    for (var c = 0; c < this.conf.evs_nodes.length; c++) {
        for (var o in this.conf.evs_nodes[c].evs) {
            if (typeof (window.addEventListener) == "function") {
                this.conf.evs_nodes[c].node.addEventListener(o, this[this.conf.evs_nodes[c].evs[o]], false);
            } else {
                this.conf.evs_nodes[c].node.attachEvent("on" + o, this[this.conf.evs_nodes[c].evs[o]]);
            }
        }
    }
    this.unload = function () {
        this.clearAll();
        this.t = null;
        for (var v = 0; v < this.conf.evs_nodes.length; v++) {
            for (var u in this.conf.evs_nodes[v].evs) {
                if (typeof (window.addEventListener) == "function") {
                    this.conf.evs_nodes[v].node.removeEventListener(u, this[this.conf.evs_nodes[v].evs[u]], false);
                } else {
                    this.conf.evs_nodes[v].node.detachEvent("on" + u, this[this.conf.evs_nodes[v].evs[u]]);
                }
                this.conf.evs_nodes[v].evs[u] = null;
                delete this.conf.evs_nodes[v].evs[u];
            }
            this.conf.evs_nodes[v].node = null;
            this.conf.evs_nodes[v].evs = null;
            delete this.conf.evs_nodes[v].node;
            delete this.conf.evs_nodes[v].evs;
            this.conf.evs_nodes[v] = null;
        }
        dhx4._eventable(this, "clear");
        dhx4._enableDataLoading(this, null, null, null, "clear");
        this._mcDetachHeader();
        this.DOMelem_input = this.DOMelem_button = this.DOMlist = this.DOMelem = this.DOMParent = null;
        for (var u12 in this.conf) {
            this.conf[u12] = null;
            delete this.conf[u12];
        }
        this.conf = null;
        if (typeof (window.addEventListener) == "function") {
            this.list.removeEventListener("scroll", this._doOnListScroll, false);
        } else {
            this.list.detachEvent("onscroll", this._doOnListScroll);
        }
        this.base.parentNode.removeChild(this.base);
        this.list.parentNode.removeChild(this.list);
        this.base = this.list = this.cont = null;
        this.modes = null;
        for (var u1 in this) {
            if (typeof (this[u1]) == "function") {
                this[u1] = null;
            }
        }
        m = null;
    };
    this.DOMelem_input = this.base.firstChild;
    this.DOMelem_button = this.base.childNodes[this.base.childNodes.length - (this.conf.combo_image ? 2 : 1)];
    this.DOMlist = this.list;
    this.DOMelem = this.base;
    this.DOMParent = l;
    l = null;
    if (g != null) {
        if (g.filter != null) {
            if (typeof (g.filter) == "string") {
                this.enableFilteringMode(true, g.filter, dhx4.s2b(g.filter_cache), dhx4.s2b(g.filter_sub_load));
            } else {
                this.enableFilteringMode(true);
            }
        }
        if (g.image_path != null) {
            this.setImagePath(g.image_path);
        }
        if (g.default_image != null || g.default_image_dis != null) {
            this.setDefaultImage(g.default_image, g.default_image_dis);
        }
        if (g.items || g.options) {
            this.addOption(g.items || g.options);
        }
        if (g.xml || g.json) {
            this.load(g.xml || g.json);
        }
        if (typeof (g.readonly) != "undefined") {
            this.readonly(g.readonly);
        }
        g = null;
    }
    return this;
}











export default dhtmlXCombo;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXCombo/dhtmlXCombo.js